<template>
  <div class="refinement toggle-all">
    <div
      class="refinement-header expander"
      role="button"
      tabindex="0"
      :aria-label="`${isAllExpanded ? 'Collapse All Filters' : 'Expand All Filters'}`"
      :aria-expanded="isAllExpanded"
      @click="expandToggle"
      @keyup.enter="expandToggle"
    >
      <h2 class="title">
        <span>{{ isAllExpanded ? 'Collapse All Filters' : 'Expand All Filters' }}</span>
      </h2>
      <div class="expand-collapse">
        <i
          class="material-symbols-outlined fill"
          aria-hidden="true"
          :data-icon="isAllExpanded ? 'collapse_all' : 'expand_all'"
        ></i>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * Handles expand and collapse for all filter groupings
 */
import { ref } from 'vue'
import { useSearchStore } from '@/stores/search'
import { cachePut } from '@/utils/local-storage-cache'

/** PROPS **/
const props = withDefaults(
  defineProps<{
    cacheKey?: string
  }>(),
  {
    cacheKey: '',
  },
)

/** STATE **/
const searchStore = useSearchStore()
const isAllExpanded = ref(
  Object.entries(searchStore.filterGroupingsExpanded).some(
    ([groupingId, isExpanded]) => isExpanded,
  ),
)

/** EMITS **/
// n/a

/** METHODS **/
function expandToggle() {
  // local state
  isAllExpanded.value = !isAllExpanded.value

  // replace pinia store to toggle all expanded / collapsed
  const filterGroupings = Object.keys(searchStore.filterGroupingsExpanded).reduce(
    (acc: Record<string, boolean>, groupingId) => {
      acc[groupingId] = isAllExpanded.value
      return acc
    },
    {},
  )

  searchStore.setFilterGroupingsExpanded(filterGroupings)

  // then save to local storage by replacing entire cache obj
  if (props.cacheKey) {
    cachePut({
      key: props.cacheKey,
      value: { ...searchStore.filterGroupingsExpanded },
    })
  }
}
</script>
